import type { Action } from 'react-sweet-state';

import type { FieldValues } from '../../../../common/types/form/form-fields/field-values';
import { currentValuesSelector } from '../../selectors/current-values';
import type { FormRendererState } from '../../types';

export const getFieldValues =
	(): Action<FormRendererState, void, FieldValues> =>
	({ getState }) => {
		const state = getState();
		const currentValues = currentValuesSelector(state);
		return currentValues;
	};
